import { Component, Input } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  @Input() bbapp: boolean = true;
  @Input() showLogos: boolean = false;
  @Input() showBrandImage: boolean = true;
  @Input() extraClass: string = '';
  translations: any;

  constructor(
    private langservice: LanguageService,
    private translationservice: TranslationService
  ) { }

  ngOnInit() {
    this.translationservice.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
  }
}
